import {Grid, ButtonBase, Typography, Drawer, IconButton, Link} from "@mui/material";
import logo from "../../Recursos/logo.svg";
import MenuIcon from '@mui/icons-material/Menu';
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const BarraCell = () => {
    const {sTab, masSM} = useResponsive()
    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const paginas = [
        { nombre: "Inicio", ruta: "/", label: "Ver proyectos de la empresa" },
        { nombre: "Servicios", ruta: "/servicios/", label: "Servicios" },
        { nombre: "Nosotros", ruta: "/nosotros/", label: "Conocer sobre nosotros" },
        { nombre: "Blog", ruta: "/blogs/", label: "Leer nuestro blog" },
        { nombre: "Contacto", ruta: "/contacto/", label: "Ir a la página de contacto" },
    ];

    return (
        <nav aria-label="Barra de navegación móvil">
            <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{position: "fixed", backgroundColor: "white", borderBottom: "1px solid #AEAEAE"}}
            >
                <Grid
                    container
                    justifyContent={"center"}
                    alignItems={"center"}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{px:3, py:1}}
                >
                    {/* Logo */}
                    <Grid
                        container
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                        size={{xs: 6, sm: 6, md: 6}}
                    >
                        <Link href="/" aria-label="Ir al inicio" title="Inicio">
                            <img
                                src={logo}
                                alt="Logo de la empresa - Desarrollo Web"
                                height={"auto"}
                                style={{cursor: "pointer", width: sTab ? "50%" : "80%"}}/>
                        </Link>
                    </Grid>

                    {/* Botón menú */}
                    <Grid
                        container
                        justifyContent={"flex-end"}
                        alignItems={"center"}
                        size={{xs: 6, sm: 6, md: 6}}
                    >
                        <ButtonBase onClick={toggleDrawer(true)} aria-label="Abrir menú de navegación">
                            <MenuIcon sx={{ fontSize: 40 }}/>
                        </ButtonBase>
                    </Grid>

                    {/* Drawer */}
                    <Drawer
                        anchor="right"
                        open={open}
                        onClose={toggleDrawer(false)}
                        PaperProps={{
                            sx: {width: 350, backgroundColor: "white"},
                        }}
                    >
                        <Grid
                            container
                            justifyContent={"flex-end"}
                            alignItems={"center"}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{px: 3}}
                        >
                            <Grid
                                container
                                justifyContent={"flex-end"}
                                size={{xs: 6, sm: 6, md: 12}}
                            >
                                <IconButton
                                    onClick={() => setOpen(false)}
                                    sx={{cursor: "pointer", pt: 2}}
                                    aria-label="Cerrar menú de navegación"
                                >
                                    <CloseIcon sx={{fontSize: 40, color: "black", fontWeight: 0}}/>
                                </IconButton>
                            </Grid>
                        </Grid>

                        {/* Lista de enlaces con ul/li */}
                        <Grid container justifyContent={"center"} alignItems={"center"} sx={{pt:10}}>
                            <ul style={{listStyle: "none", margin: 0, padding: 0, width: "100%"}}>
                                {paginas.map((pagina) => (
                                    <li key={pagina.nombre} style={{marginBottom: "16px", textAlign:"center"}}>
                                        <ButtonBase
                                            href={pagina.ruta}
                                            aria-label={pagina.label}
                                            title={pagina.nombre}
                                        >
                                            <Typography sx={{fontSize: 20, color: "black"}}>
                                                {pagina.nombre}
                                            </Typography>
                                        </ButtonBase>
                                    </li>
                                ))}
                            </ul>
                        </Grid>
                    </Drawer>
                </Grid>
            </Grid>
        </nav>
    )
}
export default BarraCell;
